export const isConflict = (message: string): boolean =>
  message.toLowerCase().includes('conflict') ||
  message.toLowerCase().includes('still referenced') ||
  message.toLowerCase().includes('foreign key');
